/** 위젯이 함께 쓰는 짧은 표기. 좁은 칸에 들어가야 해서 화면 본문보다 더 줄여 쓴다. */

const DAY_MS = 24 * 60 * 60 * 1000;

/** `오늘` · `어제` · `3일 전` · `07.02`. 일주일이 넘으면 날짜가 더 정확하다. */
export function relativeDay(value: string): string {
  const target = startOfDay(new Date(value));
  const diffDays = Math.round((startOfDay(new Date()).getTime() - target.getTime()) / DAY_MS);

  if (diffDays === 0) return '오늘';
  if (diffDays === 1) return '어제';
  if (diffDays === -1) return '내일';
  if (diffDays > 1 && diffDays <= 7) return `${diffDays}일 전`;
  if (diffDays < -1 && diffDays >= -7) return `${-diffDays}일 후`;

  return `${String(target.getMonth() + 1).padStart(2, '0')}.${String(target.getDate()).padStart(2, '0')}`;
}

/** 기한까지 남은 날. 음수면 지났다. */
export function daysUntil(dateOnly: string): number {
  const target = startOfDay(new Date(`${dateOnly}T00:00:00`));
  return Math.round((target.getTime() - startOfDay(new Date()).getTime()) / DAY_MS);
}

const WEEKDAY_LABELS = ['일', '월', '화', '수', '목', '금', '토'];

export function weekdayLabel(date: Date): string {
  return WEEKDAY_LABELS[date.getDay()] as string;
}

/** `07.24 (금)` */
export function shortDateWithWeekday(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${month}.${day} (${weekdayLabel(date)})`;
}

function startOfDay(date: Date): Date {
  const copy = new Date(date);
  copy.setHours(0, 0, 0, 0);
  return copy;
}
